import React from 'react'
import {Layout} from '../components/Layout'
import DefaultPage from './default'
import IndexPage from './index-page'
import CoursesPage from './courses-page'
import CoursePage from './course-page'
import RecorrenceCoursesPage from './recorrence-courses-page'
import RecorrenceCoursePage from './recorrence-course-page'
import RecorrencePage from './recorrence-page'
import BlogListPage from './blog-list-page'
import BlogPage from './blog-page'
import EventosPage from './eventos-page'
import PosCoursePage from './pos-course-page'
import PosCoursesPage from './pos-courses-page'
import AboutPage from './about-page'
import ProfessorPage from './professor-page'

const componentTemplateMap = {
  'index-page': IndexPage,
  'courses-page': CoursesPage,
  'course-page': CoursePage,
  'recorrencia-page': RecorrencePage,
  'recorrencia-courses-page': RecorrenceCoursesPage,
  'recorrencia-course-page': RecorrenceCoursePage,
  'blog-list-page': BlogListPage,
  'blog-page': BlogPage,
  'eventos-page': EventosPage,
  'pos-courses-page': PosCoursesPage,
  'pos-course-page': PosCoursePage,
  'about-page': AboutPage,
  'professor-page': ProfessorPage,
}

const SelectTemplate = props => {
  const Page =
    componentTemplateMap[props?.pageContext?.frontmatter?.templateKey]

  return (
    <Layout>{Page ? <Page {...props} /> : <DefaultPage {...props} />}</Layout>
  )
}

export default SelectTemplate
